import React from 'react';
import { 
  HelpCircle, 
  Building, 
  FileText, 
  PencilRuler, 
  Calendar, 
  Sun, 
  Users, 
  TrendingUp 
} from 'lucide-react';

const ArchitectureTipsSidebar = () => {
  const tips = [
    {
      icon: Building,
      title: 'Выбор архитектора',
      description: 'Выбирайте архитектора с опытом работы над проектами, схожими с вашим по типу и масштабу.'
    },
    {
      icon: FileText,
      title: 'Исходные данные',
      description: 'Подготовьте полные данные по участку: топосъемку, геологию и технические условия для коммуникаций.'
    },
    {
      icon: PencilRuler,
      title: 'Техническое задание',
      description: 'Сформулируйте четкое ТЗ с указанием площадей, функций помещений и особых требований.'
    },
    {
      icon: Calendar,
      title: 'Сроки проектирования',
      description: 'Закладывайте реалистичные сроки: качественный проект требует времени на проработку деталей.'
    },
    {
      icon: Sun,
      title: 'Энергоэффективность',
      description: 'Включите требования по энергоэффективности: это снизит эксплуатационные расходы в будущем.'
    },
    {
      icon: Users,
      title: 'Команда проекта',
      description: 'Для сложных проектов убедитесь, что в команде есть все необходимые специалисты.'
    },
    {
      icon: TrendingUp,
      title: 'Бюджет проекта',
      description: 'Заложите резерв 15-20% на непредвиденные расходы и возможные изменения в проекте.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по архитектурному проектированию
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Бесплатная консультация
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Получите профессиональную консультацию архитектора по вашему проекту. Мы поможем определить оптимальные параметры и бюджет.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Записаться на консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchitectureTipsSidebar;